module.exports = __webpack_public_path__ + "static/media/Temp-dom.92a92d4a.svg";